import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import animeConfig from '../config/animeConfig';
import storyArcs from '../data/storyArcs';
import './Guides.css';
import './ArcsPage.css';

const ArcsPage = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState('all');
  const bgStyle = {
    backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.85)), url(${animeConfig.onePiece.backgroundImage})`,
  };

  const filtered = filter === 'all'
    ? storyArcs
    : storyArcs.filter(s => s.sagaType === filter);

  const totalArcs = storyArcs.reduce((sum, s) => sum + s.arcs.length, 0);

  return (
    <>
      <Helmet>
        <title>One Piece Story Arcs - Complete Episode and Chapter Guide</title>
        <meta name="description" content={`All ${totalArcs} One Piece story arcs organized by saga with chapter and episode ranges. From Romance Dawn to the current arc.`} />
        <link rel="canonical" href="https://www.onepiecetrivia.com/arcs" />
        <meta property="og:title" content="One Piece Story Arcs" />
        <meta property="og:description" content="Every arc by saga, with its chapter and episode range, from Romance Dawn onward." />
        <meta property="og:url" content="https://www.onepiecetrivia.com/arcs" />
      </Helmet>

      <div className="guide-page-wrapper" style={bgStyle}>
        <div className="guide-container">
          <h1>Story Arcs</h1>
          <p className="guide-intro">
            Every One Piece arc with chapter and episode numbers. {totalArcs} arcs across {storyArcs.length} sagas.
          </p>

          {/* Navigation tabs */}

          {/* Filter */}
          <div className="arcs-filter">
            <button className={`arcs-filter-btn ${filter === 'all' ? 'active' : ''}`} onClick={() => setFilter('all')}>All Sagas</button>
            <button className={`arcs-filter-btn ${filter === 'first-half' ? 'active' : ''}`} onClick={() => setFilter('first-half')}>Paradise (1st Half)</button>
            <button className={`arcs-filter-btn ${filter === 'second-half' ? 'active' : ''}`} onClick={() => setFilter('second-half')}>New World (2nd Half)</button>
          </div>

          {/* Sagas */}
          {filtered.map((saga) => (
            <div key={saga.saga} className="saga-block">
              <h2 className="saga-title">{saga.saga}</h2>
              <div className="arcs-list">
                {saga.arcs.map((arc, i) => (
                  <Link key={arc.name} to={`/arcs/${arc.slug}`} className={`arc-card ${arc.filler ? 'arc-filler' : ''}`} style={{ textDecoration: 'none' }}>
                    {arc.image && (
                      <img src={arc.image} alt={arc.name} className="arc-image" loading="lazy" />
                    )}
                    <div className="arc-info">
                      <h3 className="arc-name">{arc.name}</h3>
                      {arc.filler && <span className="arc-filler-badge">Filler</span>}
                      {arc.desc && <p className="arc-desc">{arc.desc}</p>}
                      <div className="arc-details">
                        <span className="arc-detail"><span className="arc-label">Ch.</span> {arc.chapters}</span>
                        <span className="arc-detail"><span className="arc-label">Ep.</span> {arc.episodes}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}

          {/* Quiz CTA */}
          <div className="char-quiz-buttons">
            <h2>Test What You Remember</h2>
            <div className="char-quiz-row">
              <button onClick={() => navigate('/quiz')} className="char-quiz-btn">
                <img src="/character-quiz-and-any-related.png" alt="" className="char-quiz-btn-icon" />
                Character Quiz
              </button>
              <button onClick={() => navigate('/image-quiz')} className="char-quiz-btn">
                <img src="/image-quiz-and-any-related.png" alt="" className="char-quiz-btn-icon" />
                Image Quiz
              </button>
              <button onClick={() => navigate('/devil-fruit-quiz')} className="char-quiz-btn">
                <img src="/devil-fruit-quiz-and-any-related.png" alt="" className="char-quiz-btn-icon" />
                Devil Fruit Quiz
              </button>
              <button onClick={() => navigate('/bounty-battle')} className="char-quiz-btn">
                <span className="char-quiz-btn-icon game-emoji" aria-hidden="true">💰</span>
                Bounty Battle
              </button>
              <button onClick={() => navigate('/puzzle')} className="char-quiz-btn">
                <span className="char-quiz-btn-icon game-emoji" aria-hidden="true">🧩</span>
                Jigsaw Puzzle
              </button>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default ArcsPage;
